<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
        <g fill="none" fill-rule="evenodd">
            <circle cx="10.5" cy="10.5" r="10.5" fill="#44B358"/>
            <g stroke="#FFF" stroke-linecap="round" stroke-width="2">
                <path d="M.68 5.611L3.402 8.221M3.379 8.24L9.956.634" transform="translate(5 6)"/>
            </g>
        </g>
    </svg>

</template>

<script>
export default {
    name: 'tick-icon'
}
</script>

<style scoped>
svg {
    vertical-align: bottom;
    margin-right: 3px;
}
</style>
